<template>
  <AlertDialog :open="isOpen">
    <AlertDialogContent class="max-w-150 min-w-25 md:min-w-75 xl:min-w-125 max-h-[90vh] overflow-y-auto">
      <AlertDialogHeader>
        <AlertDialogDescription class="text-[#3f3f46]" v-html="$t('We use cookies...')"></AlertDialogDescription>
      </AlertDialogHeader>

      <div class="flex flex-col gap-4">
        <div class="flex items-center gap-2 flex-wrap">
          <AlertDialogAction @click="acceptAll" class="font-medium rounded-md p-4 h-8 btn btn-primary">
            {{ $t('Accept all') }}
          </AlertDialogAction>
          <AlertDialogCancel @click="rejectAll" class="font-medium rounded-md p-4 h-8">
            {{ $t('Reject All') }}
          </AlertDialogCancel>
        </div>

        <div v-cloak>
          <div v-for="category in Object.keys(settings)" class="mb-3">
            <p class="text-sm text-[#3f3f46] font-semibold" v-html="$t(settings[category]?.description ?? '')"></p>
            <span class="flex flex-wrap items-center gap-2">
              <FormKit
                type="checkbox"
                v-model="preferences[category]"
                :disabled="!settings[category]?.optional"
                :label="$t(settings[category]?.title ?? category)"
              />
            </span>
          </div>

          <div class="flex items-center gap-2 flex-wrap mt-4">
            <AlertDialogAction
              @click="savePreferences"
              class="font-medium rounded-md p-4 h-8 transition-all"
            >
              {{ $t('Save preferences') }}
            </AlertDialogAction>
          </div>
        </div>
      </div>
    </AlertDialogContent>
  </AlertDialog>
</template>

<script setup lang="ts">
import useCookies from './useCookies';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
} from '@/components/ui/alert-dialog';

const {
  isOpen,
  preferences,
  settings,
  acceptAll,
  rejectAll,
  savePreferences
} = useCookies();
</script>
